<template>
  <v-form ref="signupForm">
    <v-btn class="back-btn" @click="handleBackButton"><i class="icon-left-arrow"></i>Go
      Back</v-btn>
    <v-stepper v-model="step" alt-labels class="v-card--flat w-100">
      <!--      <v-toolbar flat v-if="step == 1">
        <h3 class="text-center blockquote pt-10">
          You are creating an account as
          <span class="font-weight-bold">{{ userType }}</span>
        </h3>
      </v-toolbar>-->
      <!-- <v-stepper-header>
        <v-stepper-step :editable="editable" :complete="step > 1" step="1">
          Basic
        </v-stepper-step>
        <v-divider />
        <v-stepper-step :editable="editable" :complete="step > 2" step="2">
          Address
        </v-stepper-step>
        <v-divider />
        <v-stepper-step :complete="step > 3" step="3">Advance</v-stepper-step>
        <v-divider />
        <v-stepper-step step="4">Done</v-stepper-step>
      </v-stepper-header> -->
      <v-stepper-items>
        <!--Selection of country and cities-->
        <v-stepper-content v-if="userType === 'Instructor'" step="1">
          <div class="tab-upper-header">
            <div class="v-img">
              <img alt="Vue" :src="require('@/assets/img/img01.svg')" />
            </div>
            <h4>What cities do you license for operating/teach in?</h4>
          </div>
          <v-form ref="signupFormStep2" class="form">
            <v-card flat class="pt-1">
              <div class="row">
                <div class="col-md-6 form-group">
                  <v-select v-model="country" :items="countries" @change="loadStateHandle" dense :rules="fieldRules"
                    outlined hide-details class="" label="Select a Country"></v-select>
                </div>
                <div class="col-md-6 form-group">
                  <v-select v-model="province" :items="states" required :rules="fieldRules" dense outlined hide-details
                    class="" label="Select a State/Province"></v-select>
                </div>
                <div class="col-md-12 form-group">
                  <v-text-field @input="loadCitiesHandle" v-model="citySearch" class="form-group" outlined label=""
                    placeholder="Select cities you operate in(you can select multiple cities)" type="text" />
                  <div v-if="dropdownCities.length > 0" class="cityLists">
                    <ul class="checkbox-lists">
                      <li :key="city.text" v-for="city in dropdownCities">
                        <div class="custom-checkbox">
                          <input :ref="`cityRef_${city.text}`" @change="selectCitiesHandle" type="checkbox"
                            :id="`select-city-${city.text}`" :value="city.text" />
                          <label style="text-transform: capitalize" :for="`select-city-${city.text}`">{{ city.text
                          }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <ul class="tag-lists">
                    <li :key="`tag-${tag}`" v-for="(tag, index) in selectCities">
                      <div class="badge-label">
                        {{ tag }}
                        <i @click="deleteTagHandle($event, index, tag)" class="icon-cross-circle" />
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <v-text-field class="form-group" outlined label="Apt/Suite #" type="text" v-model="addressTwo" />
                </div>
                <div class="col-md-12 form-group">
                  <google-autocomplete outlined :country="['ca', 'us']" ref="address11" id="mapAddress"
                    :api-key="'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0'" label="Address"
                    @place_changed="getSchoolAddressDataCity" :rules="fieldRules" />
                </div>
                <!-- <div class="col-md-6">
                  <v-text-field
                    class="form-group"
                    outlined
                    label="Street Address"
                    type="text"
                    v-model="addressOne"
                    required
                  />
                </div>
                <div class="col-md-6">
                  <v-text-field
                    class="form-group"
                    outlined
                    label="City"
                    type="text"
                    v-model="city"
                    required
                  />
                </div>
                <div class="col-md-6">
                  <v-text-field
                    class="form-group"
                    outlined
                    label="Postal/Zip Code"
                    type="text"
                    v-model="postalCode"
                    required
                  />
                </div>
                <div class="col-md-6">
                  <v-text-field
                    class="form-group"
                    outlined
                    label="Country"
                    type="text"
                    v-model="country"
                  />
                </div> -->
              </div>
              <v-row no-gutters>
                <v-spacer />
                <v-col cols="auto">
                  <v-btn color="primary" :disabled="selectCities.length === 0" @click="
                    selectCities.length > 0 &&
                    $refs.signupFormStep2.validate() &&
                    (step = 2)
                    ">
                    Continue
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>

        <!--Upload individual license for each city-->
        <v-stepper-content v-if="userType === 'Instructor'" step="2">
          <v-row>
            <v-col>
              <v-form ref="signupFormStepCityPlat2">
                <v-card flat class="pt-1">
                  <h3 class="text-center mb-5" style="text-transform: capitalize">
                    upload picture of instructing plate & type for which city
                    its for:
                  </h3>
                  <div class="btn-row progress-list">
                    <CityPlatUpload @cityPlatUploadSubmit="cityPlatUploadSubmit" :key="`asd_${city}`"
                      v-for="city in selectCities" :city="city" />
                  </div>
                </v-card>
              </v-form>
              <v-row no-gutters>
                <v-spacer />
                <v-col cols="auto">
                  <v-btn color="primary" @click="
                    instructorCityPlat.length === selectCities.length &&
                    $refs.signupFormStepCityPlat2.validate() &&
                    (step = 3)
                    " :loading="loading" :disabled="loading">Continue</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!--Instructing license + name, email, password-->
        <v-stepper-content v-if="userType === 'Instructor'" step="3">
          <v-form ref="signupFormStep11">
            <v-card flat>
              <div class="row">
                <!--Driving license-->
                <div class="col-md-12 form-group">
                  <div class="custom-fileupload">
                    <input id="fileupload" type="file" @change="onAvatarChangeDrivingLicense" class="fileUpload" />
                    <div class="fileupload-content">
                      <label v-if="drivingLicensePreview.length === 0" class="form-label" for="fileupload">
                        <div class="upload-content">
                          <div class="icon-box">
                            <i class="icon-upload">
                              <span class="path1"></span>
                            </i>
                          </div>
                          Upload picture of driving license
                        </div>
                      </label>
                      <div v-if="drivingLicensePreview.length > 0" class="image-preview">
                        <img :src="drivingLicensePreview" alt="" />
                        <v-progress-linear v-if="progressValue > 0" color="red lighten-2" :query="true"
                          :value="progressValue"></v-progress-linear>
                        <v-btn class="close-btn" @click="drivingLicensePreview = ''"><i class="mdi mdi-close" />
                          Remove</v-btn>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Instructing license + profile information-->
                <div class="col-md-12 form-group">
                  <div class="custom-fileupload">
                    <input id="fileuploadIL" type="file" @change="onAvatarChangeInstructorLicense" class="fileUpload" />
                    <div class="fileupload-content">
                      <label v-if="instructorLicensePreview.length === 0" class="form-label" for="fileuploadIL">
                        <div class="upload-content">
                          <div class="icon-box">
                            <i class="icon-upload">
                              <span class="path1"></span>
                            </i>
                          </div>
                          Upload picture of instructing license
                        </div>
                      </label>
                      <div v-if="instructorLicensePreview.length > 0" class="image-preview">
                        <img :src="instructorLicensePreview" alt="" />
                        <v-progress-linear v-if="progressValueIL > 0" color="red lighten-2" :query="true"
                          :value="progressValueIL"></v-progress-linear>
                        <v-btn class="close-btn" @click="instructorLicensePreview = ''"><i class="mdi mdi-close" />
                          Remove</v-btn>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field outlined dense label="First Name *" type="text" :rules="fieldRules" v-model="firstName"
                    name="firstName" required />
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field outlined dense label="Last Name *" type="text" :rules="fieldRules" v-model="lastName"
                    name="lastName" required />
                </div>
                <div class="col-md-12 form-group">
                  <v-text-field dense outlined label="Email *" type="email" @input="emailHandleExist"
                    :rules="emailRules" v-model="email" aria-autocomplete="off" required />
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field dense outlined label="Password" type="password" :rules="passwordRules"
                    v-model="password" required />
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field dense outlined label="Confirm Password *" type="password" :rules="confirmPasswordRules"
                    v-model="confirmPassword" required />
                </div>

                <div class="col-md-12 form-group">
                  <v-dialog ref="birthDateDialog" v-model="birthDateDialogModal" :return-value.sync="birthDate"
                    persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field outlined dense name="birthDate" v-model="birthDate" label="Birthday *" readonly
                        v-bind="attrs" v-on="on" required :rules="fieldRules" />
                    </template>
                    <v-date-picker v-model="birthDate" type="date" name="birthDate" max="2004-12-31" scrollable
                      picker-date>
                      <v-btn small color="primary" @click="birthDateDialogModal = false">Cancel</v-btn>
                      <v-spacer />
                      <v-btn small color="primary" @click="$refs.birthDateDialog.save(birthDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
                <!--                <div class="col-md-4 form-group">
                  <v-select
                    v-model="countryCode"
                    :items="countryCodes"
                    name="countryCode"
                    dense
                    :rules="fieldRules"
                    outlined
                    hide-details
                    class=""
                    label="Select a Country Code"
                  ></v-select>
                </div>
                <div class="col-md-8 form-group">
                  <v-text-field
                    dense
                    outlined
                    label="Phone *"
                    type="text"
                    :rules="phoneNumberRules"
                    v-model="phone"
                    name="phone"
                    required
                  />
                  <span>We would approve your phone number by sending sms </span>

                </div>-->
                <div class="col-md-12 form-group">
                  <vue-tel-input-vuetify v-model="myPhone" dense outlined
                    :preferred-countries="['id', 'gb', 'ua', 'us']" :valid-characters-only="true" select-label="Code"
                    @input="onInput" />
                  <small class="d-block">We would approve your phone number by sending sms
                  </small>
                </div>
              </div>
              <v-row no-gutters>
                <v-spacer />
                <v-col cols="auto">
                  <v-btn color="primary" ref="phoneVerificationButton"
                    :disabled="userType === 'Student' && isEmailExist"
                    @click="validateStepThree">Continue</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>

        <!--Phone number verification-->
        <v-dialog v-model="isPhoneNumberPopup" persistent width="500">
          <v-card style="padding: 50px">
            <button @click="closeOtpDialog" class="btn-close" type="button">
              <i class="mdi mdi-close"></i>
            </button>
            <v-card-text>
              <div class="tab-upper-header">
                <div class="v-img">
                  <img alt="Congratulations" :src="require('@/assets/img/popupimg.svg')" />
                </div>
              </div>
              <div class="text-center">
                <h4 style="font-size: 21px; line-height: 30px; font-weight: 400">
                  Verify Your Phone Number
                </h4>
                <p class="otp-subtext">
                  Please enter the verification code we've sent by SMS to
                  <strong>{{ phone }}</strong>.
                </p>
                <div v-if="otpCountdown > 0" class="otp-timer">
                  <i class="mdi mdi-timer-outline"></i>
                  Code expires in <strong>{{ otpCountdownLabel }}</strong>
                </div>
                <div v-else class="otp-timer otp-timer-expired">
                  <i class="mdi mdi-timer-off-outline"></i>
                  Your code has expired — close this window and tap Continue to receive a new one.
                </div>
                <div class="row">
                  <div class="col-md-12 form-group">
                    <v-text-field outlined dense label="Code" type="text" :rules="fieldRules" v-model="phoneCode"
                      @input="otpError = ''" required />
                  </div>
                </div>
                <div v-if="otpError" class="otp-error">
                  <i class="mdi mdi-alert-circle-outline"></i> {{ otpError }}
                </div>

                <v-btn ref="verifyPhoneNumberButton" style="margin-top: 30px" color="primary" type="button" light
                  :disabled="otpCountdown === 0" @click="phoneVerificationSubmit">Verify</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-stepper-content v-if="userType === 'Instructor'" step="4">
          <v-form ref="signupFormStep3">
            <v-card flat class="pt-1">
              <v-row align="center" class="pb-4">
                <v-col cols="auto" class="py-0">
                  <v-dialog v-model="cropDialog" max-width="320" persistent>
                    <crop :img="imgBlob" @crop="croppedImage = $event" @cancel="cropDialog = $event" />
                  </v-dialog>
                  <v-btn color="primary" v-if="!avatarPreview" fab :loading="loadingPreview">
                    <v-icon dark>mdi-account-circle</v-icon>
                  </v-btn>
                  <v-avatar v-else color="primary" size="56" class="mb-5">
                    <img :src="avatarPreview" :alt="firstName" />
                  </v-avatar>
                </v-col>
                <v-col class="pb-0">
                  <v-file-input dense outlined show-size label="Avatar *" :rules="fileRules"
                    accept="image/png, image/jpeg, image/bmp" prepend-icon v-model="avatar" @change="onAvatarChange"
                    required v-if="isWeb" />
                  <template v-else>
                    <v-file-input dense outlined class="d-none" show-size required prepend-icon label="Avatar *"
                      accept="image/png, image/jpeg, image/bmp" v-model="avatar" :rules="fieldRules" />
                    <v-dialog v-model="avatarDialog" width="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn outlined v-bind="attrs" v-on="on" block class="mb-3" elevation="0" depressed
                          :loading="isSelecting">
                          <v-icon left> mdi-checkbox-marked-outline </v-icon>
                          {{ avatarButtonText }}
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-text class="pt-6">
                          <v-row>
                            <v-col>
                              <div class="px-4 py-3 rounded-lg option-card flex-column" style="height: 100%"
                                @click="uploadAvatar('Capture')">
                                <v-icon large>mdi-camera</v-icon>
                                <h3 class="mb-0">Capture</h3>
                              </div>
                            </v-col>
                            <v-col>
                              <div class="px-4 py-3 rounded-lg option-card flex-column" style="height: 100%"
                                @click="uploadAvatar('Choose from library')">
                                <v-icon large> mdi-image </v-icon>
                                <h3 class="mb-0">From library</h3>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </template>
                </v-col>
              </v-row>
              <v-row>
                <!-- <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  dense
                  outlined
                  label="Licence Number *"
                  prepend-icon="mdi-av-timer"
                  type="text"
                  :rules="fieldRules"
                  v-model="licenceNumber"
                />
              </v-col> -->
                <v-col cols="12" md="6" class="py-0">
                  <v-file-input dense outlined show-size label="Upload Licence *" :rules="fileRules"
                    prepend-icon="mdi-file-document" v-model="licence" @change="onLicenceChange" />
                </v-col>

                <v-col cols="12" md="6" class="py-0" v-if="userType === 'Instructor'">
                  <v-file-input dense outlined show-size label="Instructor Licence *" :rules="fileRules"
                    prepend-icon="mdi-file-document" v-model="instructorLicence" @change="onInstructorLicenceChange" />
                </v-col>
              </v-row>
              <v-row v-if="userType === 'Instructor'">
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field dense outlined label="Plate Number *" prepend-icon="mdi-car" type="text"
                    :rules="fieldRules" v-model="carPlateNumber" />
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field dense outlined label="Instructing Plate Numbers (separate by comma) *"
                    prepend-icon="mdi-speedometer" type="text" :rules="fieldRules" required
                    v-model="instructingPlateNumber" />
                </v-col>
              </v-row>

              <v-autocomplete dense v-if="userType === 'Instructor'" :items="filteredSchools"
                item-text="attributes.name" item-value="id" outlined label="Driving School" prepend-icon="mdi-school"
                v-model="school" :search-input.sync="populateSchools" :messages="[
                  'You can associate yourself with a school from the list which is optional. Or...',
                ]" hide-no-data />
              <v-checkbox class="mt-0" label="Operate Independently" v-model="notWithAnySchool"
                v-if="userType === 'Instructor'" />
              <v-autocomplete dense v-if="userType === 'Instructor'" v-model="cities" :items="filteredCities" outlined
                prepend-icon="mdi-city-variant" label="Cities you operate in *" :rules="fieldRules" multiple chips
                small-chips deletable-chips hide-selected :search-input.sync="populateCities" hide-no-data required />
            </v-card>
          </v-form>
          <v-row no-gutters>
            <v-col>
              <v-btn color="primary" @click="step = 2">Prev</v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-btn color="primary" @click="$refs.signupFormStep3.validate() && (step = 4)" :loading="loading"
                :disabled="loading">Submit</v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!-- Congratulations-->
        <v-stepper-content v-if="userType === 'Instructor'" step="6">
          <v-row>
            <v-col>
              <SchoolRates :instructorData="instructorData" @moveToLastStep="moveToLastStepHandle" />

              <v-dialog v-model="showLastStep" persistent width="500">
                <v-card style="padding: 50px">
                  <v-card-text>
                    <div class="tab-upper-header">
                      <div class="v-img">
                        <img alt="Congratulations" :src="require('@/assets/img/popupimg.svg')" />
                      </div>
                    </div>
                    <div class="text-center">
                      <h4 style="
                          font-size: 21px;
                          line-height: 30px;
                          font-weight: 400;
                        ">
                        <span class="text-green">Congratulations</span>, you've
                        finished the first step in becoming a driving instructor
                        with DriverX. One of our representatives will contact
                        you within 48hours to complete
                      </h4>
                      <v-btn style="margin-top: 30px" color="primary" light @click="dialogCloseHandle">Continue</v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!--Select school on map, deprecated-->
        <v-stepper-content v-if="userType === 'Instructor'" step="101">
          <v-row>
            <v-col>
              <v-form ref="signupFormStepCityPlatEmail">
                <v-card flat class="pt-1" style="margin-top: 50px !important">
                  <!-- <div class="social-signup-wrapper">
                    <v-btn block outlined large class="social-btn google-btn mb-3">
                      <v-icon left color="#DB4437">mdi-google</v-icon>
                      <span>Sign up with Google</span>
                    </v-btn>
                    <v-btn block dark large class="social-btn apple-btn" color="#000000">
                      <v-icon left>mdi-apple</v-icon>
                      <span>Sign up with Apple</span>
                    </v-btn>
                    <div class="social-signup-divider">
                      <span>or</span>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-md-12 form-group">
                      <v-text-field dense outlined label="Email *" type="email" @input="emailHandleExist"
                        :rules="emailRules" v-model="email" aria-autocomplete="off" required />
                    </div>
                    <div class="col-md-6 form-group">
                      <v-text-field dense outlined label="Password" type="password" :rules="passwordRules"
                        v-model="password" required />
                    </div>
                    <div class="col-md-6 form-group">
                      <v-text-field dense outlined label="Confirm Password *" type="password"
                        :rules="confirmPasswordRules" v-model="confirmPassword" required />
                    </div>
                    <div class="col-md-12 form-group">
                      <google-autocomplete outlined :country="['ca', 'us']" ref="address1" id="mapAddress"
                        :api-key="'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0'" label="Address"
                        @place_changed="getSchoolAddressData" :rules="fieldRules" />
                    </div>
                  </div>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="auto">
                      <v-btn color="primary" :disabled="isEmailExist" @click="submitValidateStepFour">
                        Continue
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!--Enter school manually, deprecated-->
        <v-stepper-content v-if="userType === 'Instructor'" step="102">
          <v-row>
            <v-col>
              <v-form ref="signupFormStepCityPlat1">
                <v-card flat class="pt-1">
                  <div>
                    <!--                    <DriverX @SchoolSelected="SchoolSelectedDBSchool"/>-->
                    <OperateIndependently @SchoolSelected="SchoolSelectedHandle" />
                  </div>
                  <v-row class="pt-2 cutom-row">
                    <v-col v-if="operateModel === true" class="col mb-2">
                      <v-btn color="primary" @click="
                        $refs.signupFormStepCityPlat1.validate() && (step = 5)
                        ">Enter Location Manually
                      </v-btn>
                    </v-col>
                    <v-col class="col text-right mb-2">
                      <v-btn color="primary" @click="
                        operateModel === true
                          ? $refs.signupFormStepCityPlat1.validate() &&
                          (step = 5)
                          : $refs.signupFormStepCityPlat1.validate() &&
                          (step = 6)
                        " :loading="loading" :disabled="!isSelectSchool">Continue</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!-- Manual school location, deprecated-->
        <v-stepper-content v-if="userType === 'Instructor'" step="103">
          <v-row>
            <v-col>
              <v-form ref="schoolLocationAddManually">
                <v-card flat class="pt-1">
                  <h3 class="text-center mb-5">
                    Enter Institute/School Location
                  </h3>
                  <div class="row">
                    <div class="col-md-12 form-group">
                      <v-text-field outlined dense label="Institute/School" type="text" :rules="fieldRules"
                        v-model="schoolName" required />
                    </div>
                    <div class="col-md-12 form-group">
                      <v-text-field outlined dense label="Contact Number" type="text" :rules="fieldRules"
                        v-model="schoolContactNumber" required />
                    </div>
                    <div class="col-md-12 form-group">
                      <v-text-field outlined dense label="Email is optional" type="text" v-model="schoolEmail" />
                    </div>
                    <div class="col-md-12 form-group">
                      <v-text-field outlined dense label="Address" type="text" :rules="fieldRules"
                        v-model="schoolAddress" required />
                    </div>
                  </div>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="auto">
                      <v-btn color="primary" @click="
                        $refs.schoolLocationAddManually.validate() &&
                        (step = 6)
                        " :loading="loading">Continue</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content v-if="userType === 'Student'" step="1">
          <ZipCodeForm @continue="handleContinue" />
        </v-stepper-content>

        <v-stepper-content v-if="userType === 'Student'" width="100%" v-show="step === 2" step="2">
          <PackagePlanBoxes @packageSelected="selectPackage" />
        </v-stepper-content>

        <v-stepper-content v-if="userType === 'Student'" step="3">
          <div class="studentStepForm">
            <h1 class="text-center fw-normal mb-4">
              Create your <b class="text-green">student account</b>
            </h1>
            <v-form ref="signupFormStep11">
              <div class="row">
                <div class="col-md-12 form-group">
                  <v-text-field dense outlined label="Email *" type="email" @input="emailHandleExist"
                    :rules="emailRules" v-model="email" aria-autocomplete="off" required />
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field dense outlined label="Password" type="password" :rules="passwordRules"
                    v-model="password" required />
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field dense outlined label="Confirm Password *" type="password" :rules="confirmPasswordRules"
                    v-model="confirmPassword" required />
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field outlined dense label="First Name *" type="text" :rules="fieldRules" v-model="firstName"
                    name="firstName" required />
                </div>
                <div class="col-md-6 form-group">
                  <v-text-field outlined dense label="Last Name *" type="text" :rules="fieldRules" v-model="lastName"
                    name="lastName" required />
                </div>
                <!--                <div class="col-md-4 form-group">
                  <v-select
                    v-model="countryCode"
                    name="countryCode"
                    :items="countryCodes"
                    dense
                    :rules="fieldRules"
                    outlined
                    hide-details
                    class=""
                    label="Select a Country Code"
                  ></v-select>
                </div>
                <div class="col-md-8 form-group">
                  <v-text-field
                    dense
                    outlined
                    label="Phone *"
                    type="tel"
                    :rules="fieldRules"
                    v-model="phone"
                    name="phone"
                    required
                  />
                  <span>We would approve your phone number by sending sms </span>
                </div>-->
                <div class="col-md-12 form-group">
                  <vue-tel-input-vuetify v-model="myPhone" dense outlined
                    :preferred-countries="['id', 'gb', 'ua', 'us']" :valid-characters-only="true" select-label="Code"
                    @input="onInput" />
                  <small class="d-block">We would approve your phone number by sending sms
                  </small>
                </div>
                <div class="col-md-12 form-group">
                  <google-autocomplete
                    ref="address11Student"
                    outlined
                    :country="['ca']"
                    :component-restrictions="{ country: 'ca' }"
                    :bounds="ontarioBounds"
                    :api-key="'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0'"
                    label="Address (Ontario Only)"
                    @place_changed="getSchoolAddressDataCity"
                    @input="onStudentAddressInput"
                    :rules="fieldRules"
                    :error="!!addressError"
                    :error-messages="addressError ? [addressError] : []"
                  />
                </div>
                <div class="col-md-12 form-group">
                  <v-text-field
                    dense
                    outlined
                    label="City"
                    type="text"
                    :rules="fieldRules"
                    v-model="city"
                    required
                    disabled
                  />
                </div>
              </div>
              <div class="form-group text-center">
                <v-btn color="primary" ref="phoneVerificationButton"
                  :disabled="userType === 'Student' && (isEmailExist || !hasValidOntarioAddress)"
                  @click="validateStepThree">Continue</v-btn>
              </div>
            </v-form>
            <p class="studentStepTrust">
              <v-icon size="15">mdi-shield-check</v-icon>
              Your information is secure and never shared
            </p>
          </div>
        </v-stepper-content>

        <v-stepper-content v-if="userType === 'Student'" step="4">
          <div class="studentStepForm">
            <h1 class="text-center fw-normal mb-4">
              Almost done — complete your <b class="text-green">profile</b>
            </h1>
            <v-form ref="signupFormStep1">
            <v-card flat>
              <!-- <div class="social-signup-wrapper">
                <v-btn block outlined large class="social-btn google-btn mb-3">
                  <v-icon left color="#DB4437">mdi-google</v-icon>
                  <span>Sign up with Google</span>
                </v-btn>
                <v-btn block dark large class="social-btn apple-btn" color="#000000">
                  <v-icon left>mdi-apple</v-icon>
                  <span>Sign up with Apple</span>
                </v-btn>
                <div class="social-signup-divider">
                  <span>or</span>
                </div>
              </div> -->
              <div class="row">
                <div class="col-md-12 form-group">
                  <v-dialog ref="birthDateDialog" v-model="birthDateDialogModal" :return-value.sync="birthDate"
                    persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field outlined dense v-model="birthDate" name="birthDate" label="Birthday *" readonly
                        v-bind="attrs" v-on="on" required :rules="fieldRules" />
                    </template>
                    <v-date-picker v-model="birthDate" name="birthDate" type="date" scrollable picker-date>
                      <v-btn small color="primary" @click="birthDateDialogModal = false">Cancel</v-btn>
                      <v-spacer />
                      <v-btn small color="primary" @click="$refs.birthDateDialog.save(birthDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>

                <div class="col-md-12 form-group">
                  <div class="custom-fileupload">
                    <input id="fileupload1" type="file" @change="onAvatarChangeDrivingLicense" class="fileUpload" />
                    <div class="fileupload-content">
                      <label v-if="drivingLicensePreview.length === 0" class="form-label" for="fileupload1">
                        <div class="upload-content">
                          <div class="icon-box">
                            <i class="icon-upload">
                              <span class="path1"></span>
                            </i>
                          </div>
                          Upload picture of license (Optional).
                        </div>
                      </label>
                      <div v-if="drivingLicensePreview.length > 0" class="image-preview">
                        <v-progress-linear v-if="progressValue > 0" color="lime" :query="true"
                          :value="progressValue"></v-progress-linear>
                        <img :src="drivingLicensePreview" alt="" />
                        <v-btn class="close-btn" @click="drivingLicensePreview = ''"><i class="mdi mdi-close" />
                          Remove</v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group text-center">
                <v-btn
                  color="primary"
                  @click="submitStudent"
                  :loading="loading"
                >Submit</v-btn>
              </div>
            </v-card>
            </v-form>
          </div>
        </v-stepper-content>
        <!-- Where did you hear about us? (between signup and checkout) -->
        <v-stepper-content v-if="userType === 'Student'" step="7">
          <v-card flat>
            <v-row justify="center">
              <v-col cols="12" class="py-10">
                <div class="hear-about-step">
                  <div class="hear-about-step-head">
                    <div class="hear-about-badge">
                      <v-icon color="white" size="26">mdi-bullhorn</v-icon>
                    </div>
                    <h2 class="hear-about-step-title">Where did you hear about us?</h2>
                    <p class="hear-about-subtitle">
                      One quick tap before checkout — it helps us reach more students like you
                    </p>
                  </div>

                  <div class="hear-about-grid">
                    <button v-for="opt in hearAboutOptions" :key="opt.value" type="button" class="hear-about-chip"
                      :class="{ selected: heardAboutUs === opt.value }" @click="selectHearAbout(opt.value)">
                      <v-icon class="hear-about-chip-icon">{{ opt.icon }}</v-icon>
                      <span>{{ opt.label }}</span>
                      <v-icon v-if="heardAboutUs === opt.value" class="hear-about-check">mdi-check-circle</v-icon>
                    </button>
                  </div>

                  <v-expand-transition>
                    <div v-if="heardAboutUs === 'Other'" class="hear-about-other">
                      <v-text-field v-model="heardAboutUsOther" placeholder="Tell us where (optional)" outlined dense
                        hide-details maxlength="120" />
                    </div>
                  </v-expand-transition>

                  <v-btn block large color="primary" class="hear-about-continue" :disabled="!heardAboutUs"
                    :loading="hearAboutSaving" @click="hearAboutContinue">
                    Continue to Checkout
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content v-if="userType === 'Student'" step="5">
          <v-card flat>
            <v-row align="center">
              <v-col cols="12" class="py-16">
                <!-- <div class="d-flex justify-space-between"></div> -->
                <h2 class="mb-4 hidden-sm-and-down">Order Summary</h2>
                <div class="d-flex mb-4 justify-space-between">
                  <h3>{{ packageData.title }}</h3>
                  <h3>
                    <span v-if="isPackageDiscountActive" class="os-original-price">${{ packageData.originalPrice }}</span>
                    $ {{ packageData.price }}
                    {{ this.paramPriceId ? "( Pay in 5 installments )" : "" }}
                  </h3>
                </div>

                <!-- Limited-time discount banner -->
                <div v-if="isPackageDiscountActive" class="discount-banner">
                  <div class="discount-banner-left">
                    <span class="discount-banner-bolt">⚡</span>
                    <div>
                      <div class="discount-banner-title">
                        Limited-time discount applied — save ${{ packageSavings }} ({{ packageSavePercent }}% OFF)
                      </div>
                      <div class="discount-banner-sub">
                        You pay <strong>${{ packageData.price }}</strong> instead of
                        <s>${{ packageData.originalPrice }}</s>. Offer ends soon — complete signup to lock it in.
                      </div>
                    </div>
                  </div>
                  <div class="discount-banner-timer">
                    <span class="dc-chip">{{ packageDiscountCountdown.h }}<sub>H</sub></span>
                    <span class="dc-sep">:</span>
                    <span class="dc-chip">{{ packageDiscountCountdown.m }}<sub>M</sub></span>
                    <span class="dc-sep">:</span>
                    <span class="dc-chip">{{ packageDiscountCountdown.s }}<sub>S</sub></span>
                  </div>
                </div>

                <div v-html="packageData.packageDetails"></div>
                <div>
                  <br />
                  <br />
                  <h3>
                    Price: $ {{ packageData.price }}
                    <!-- Price: ${{ Math.round(packageData.price * (1 - packageData.discountPercentage / 100)) }} -->
                  </h3>
                  <h3 v-if="packageData.taxApplicable">
                    HST (13%): ${{
                      this.paramPriceId
                        ? (124.07 * 0.13).toFixed(2)
                        : (Math.round(packageData.price * (1 - (packageData.discountPercentage || 0) / 100)) *
                          0.13).toFixed(2)
                    }}
                  </h3>

                  <!-- Coupon Discount Display -->
                  <div v-if="appliedCoupon" class="coupon-discount-display">
                    <h3 class="coupon-discount-text">
                      Coupon Discount ({{ appliedCoupon.discount }}%): -${{ this.calculateCouponDiscount() }}
                    </h3>
                  </div>

                  <!-- Coupon Section -->
                  <div class="coupon-section">
                    <div class="coupon-header">
                      <v-icon class="coupon-icon">mdi-ticket-percent</v-icon>
                      <h4 class="coupon-title">Have a Coupon?</h4>
                    </div>

                    <div class="coupon-form">
                      <div class="coupon-input-group">
                        <v-text-field v-model="couponCode" placeholder="Enter coupon code" outlined dense hide-details
                          class="coupon-input" @keyup.enter="applyCoupon"></v-text-field>
                        <v-btn @click="applyCoupon" :loading="couponLoading" :disabled="!couponCode.trim()"
                          color="primary" class="coupon-btn">
                          Apply
                        </v-btn>
                      </div>

                      <!-- Coupon Status Messages -->
                      <div v-if="couponMessage" class="coupon-message" :class="couponMessageType">
                        <v-icon v-if="couponMessageType === 'success'" class="mr-2">mdi-check-circle</v-icon>
                        <v-icon v-else-if="couponMessageType === 'error'" class="mr-2">mdi-alert-circle</v-icon>
                        <v-icon v-else class="mr-2">mdi-information</v-icon>
                        {{ couponMessage }}
                      </div>

                      <!-- Applied Coupon Display -->
                      <div v-if="appliedCoupon" class="applied-coupon">
                        <div class="coupon-details">
                          <div class="coupon-info">
                            <span class="coupon-code">{{ appliedCoupon.code }}</span>
                            <span class="coupon-discount">{{ appliedCoupon.discount }}% OFF</span>
                          </div>
                          <div class="coupon-description">{{ appliedCoupon.description }}</div>
                          <div class="coupon-expiry">Valid until {{ formatDate(appliedCoupon.expiryDate) }}</div>
                        </div>
                        <v-btn @click="removeCoupon" color="error" small outlined class="remove-coupon-btn">
                          Remove
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <br />
                  <h2>
                    Total: ${{
                      this.calculateFinalTotal()
                    }}
                    <span v-if="appliedCoupon" class="coupon-applied-text">
                      <br><small>After {{ appliedCoupon.discount }}% discount</small>
                    </span>
                  </h2>
                </div>
                <div class="text-end">
                  <v-btn color="primary" @click="handleCheckout">Checkout</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-content v-if="userType === 'Student'" step="6">
          <v-card flat>
            <v-row justify="center" align="center">
              <v-col cols="8" class="py-16 text-center">
                <h1 class="mb-4 hidden-sm-and-down">Congratulations!</h1>
                <h2 class="mb-2 hidden-md-and-up">Congratulations!</h2>
                <p v-if="userType === 'student'">
                  Enjoy full control of your driving school plan: find the right
                  instructor, book lessons catered to your needs, take fun and
                  interactive courses to get your certificate online, and make
                  payments right through the app.
                </p>
                <p v-if="userType === 'instructor'">
                  Connect with new students, simplify your schedule &amp; manage
                  and receive instant payments through our user-friendly app.
                  For approval or your application is being approved please
                  allow 2-5 business days
                </p>
                <p>
                  Your account has been created successfully. Please login to
                  continue.
                </p>
                <v-btn color="primary" @click="goToLogin">Login</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog class="progressDialog" v-model="progressDialog" hide-overlay persistent width="350">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="errorDialogModal" width="500">
      <v-alert prominent type="error">
        <v-row align="center">
          <v-col class="grow">{{ this.alertMessage }}</v-col>
          <v-col class="shrink">
            <v-btn color="white" light @click="errorDialogModal = false">
              Ok
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>

    <!-- Discount-expired dialog (matches site UI) -->
    <v-dialog v-model="discountDialog.show" max-width="460" persistent>
      <v-card class="discount-dialog-card">
        <div class="discount-dialog-header">
          <div class="discount-dialog-icon">
            <v-icon color="white">mdi-clock-alert-outline</v-icon>
          </div>
          <h3 class="discount-dialog-title">{{ discountDialog.title }}</h3>
        </div>
        <div class="discount-dialog-body">
          <p class="discount-dialog-text">
            The limited-time discount on
            <strong>"{{ discountDialog.packageTitle }}"</strong>
            has just ended.
          </p>
          <div class="discount-dialog-prices">
            <div class="dd-price-block dd-old">
              <span class="dd-label">Discounted</span>
              <span class="dd-value"><s>${{ discountDialog.oldPrice }}</s></span>
            </div>
            <v-icon class="dd-arrow">mdi-arrow-right</v-icon>
            <div class="dd-price-block dd-new">
              <span class="dd-label">New price</span>
              <span class="dd-value">${{ discountDialog.newPrice }}</span>
            </div>
          </div>
          <p v-if="discountDialog.mode === 'confirm'" class="discount-dialog-sub">
            Continue with the regular price, or go back to review your order.
          </p>
          <p v-else class="discount-dialog-sub">
            Your order summary has been updated to the regular price.
          </p>
        </div>
        <div class="discount-dialog-actions">
          <v-btn
            v-if="discountDialog.mode === 'confirm'"
            text
            class="discount-dialog-cancel"
            @click="closeDiscountDialog(false)"
          >
            Go back
          </v-btn>
          <v-btn
            depressed
            class="discount-dialog-proceed"
            @click="closeDiscountDialog(true)"
          >
            {{ discountDialog.mode === 'confirm' ? 'Continue at regular price' : 'Got it' }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
/* eslint-disable semi, indent, comma-dangle, space-before-function-paren, eqeqeq */
import Parse from 'parse'
import { mapGetters, mapActions } from 'vuex'
import rawCities from 'cities.json'
import validationRules from '@/validation-rules'
import Crop from '@/components/common/Crop'
import CityPlatUpload from './CityPlatUpload'
import VueTelInputVuetify from './countryCode/vue-tel-input-vuetify.vue'
import OperateIndependently from './OperateIndependently'
import SchoolRates from './SchoolRates'
import ZipCodeForm from '@/components/ZipCodeForm.vue'
import PackagePlanBoxes from '@/components/PackagePlanBoxes.vue'
import {
  customValidate,
  isValidEmail,
  removeDuplicateItem
} from '../../Helper'
import axios from 'axios'
import { loadStripe } from '@stripe/stripe-js'

const selectedCities = rawCities
  .filter(({ country }) => country === 'CA')
  .map(({ name }) => name)

export default {
  components: {
    SchoolRates,
    OperateIndependently,
    CityPlatUpload,
    VueTelInputVuetify,
    Crop,
    ZipCodeForm,
    PackagePlanBoxes
  },
  props: {
    userType: {
      type: String,
      default: 'instructor'
    },
    handleAuth: Function
  },

  data() {
    return {
      loading: false,
      /** Where did you hear about us (own step before checkout) */
      heardAboutUs: '',
      heardAboutUsOther: '',
      hearAboutSaving: false,
      hearAboutOptions: [
        { value: 'Google Search', label: 'Google Search', icon: 'mdi-google' },
        { value: 'Instagram', label: 'Instagram', icon: 'mdi-instagram' },
        { value: 'TikTok', label: 'TikTok', icon: 'mdi-music-note' },
        { value: 'Facebook', label: 'Facebook', icon: 'mdi-facebook' },
        { value: 'YouTube', label: 'YouTube', icon: 'mdi-youtube' },
        { value: 'Friend or Family', label: 'Friend / Family', icon: 'mdi-account-group' },
        { value: 'My School', label: 'My School', icon: 'mdi-school' },
        { value: 'Other', label: 'Other', icon: 'mdi-dots-horizontal' }
      ],
      phoneNumberRules: [
        (value) => !!value || 'Required.',
        (value) => (value || '').length <= 20 || 'Max 20 characters',
        (value) => {
          const pattern = /^[0-9]+$/
          return pattern.test(value) || 'Invalid Phone Number.'
        }
      ],
      progressDialog: false,
      countries: [],
      states: [],
      dropdownCities: [],
      countryCode: '',
      countryCodes: [
        {
          value: '+92',
          text: ' Pakistan +92'
        },
        {
          value: '+1',
          text: ' US ,Canada +1'
        }
      ],
      isEmailExist: true,
      myPhone: '',
      isPhoneNumberPopup: false,
      /** OTP dialog: countdown + inline error */
      otpCountdown: 0,
      otpTimerHandle: null,
      otpError: '',
      otpSentToPhone: '',
      adminNotified: false,
      isPhoneVerify: false,
      phoneCode: '',
      isSelectSchool: false,
      drivingLicensePreview: '',
      instructorLicensePreview: '',
      operateModel: false,
      showLastStep: false,
      progressValue: 0,
      progressValueIL: 0,
      schoolId: 'SH8HBVt2pk', // for now just driverX
      drivingLicense: {},
      instructorLicense: {},
      schoolName: '',
      schoolContactNumber: '',
      schoolEmail: '',
      schoolAddress: '',
      // selectCities: ['Abc City Name', 'Abc City Name 2', 'Abc City Name 3'],
      selectCities: [],
      instructorCityPlat: [],
      citySearch: '',
      alertMessage:
        'Please check all the steps and fill up the required fields',
      birthDateDialogModal: false,
      notWithAnySchool: false,
      errorDialogModal: false,
      step: 1,
      editable: true,
      firstName: '', //
      lastName: '', //
      birthDate: '2005-01-01', // new Date(2004, 8, 31) // '2004-12-31'
      email: '', //
      phone: '', //
      password: '', ///
      confirmPassword: '',
      avatarDialog: false,
      cropDialog: false,
      imgBlob: null,
      croppedImage: null,
      isAvatarSelecting: false,
      avatar: null,
      avatarURL: '',
      isWeb: true,
      avatarPreview: null,
      loadingPreview: false,
      agree: false,
      licenceNumber: [],
      licence: null,
      instructorLicence: null,
      licenceURL: '',
      instructorLicenceURL: '',
      carPlateNumber: '',
      cities: '',
      addressOne: '',
      addressTwo: '',
      on: '',
      postalCode: '',
      city: '',
      province: '',
      country: '',
      address: '',
      latitude: '',
      longitude: '',
      school: '',
      paramPackageId: '',
      paramPriceId: '',
      paramType: '',
      packageData: '',
      nowTs: Date.now(),
      _discountTickInterval: null,
      _discountExpiredHandled: false,
      discountDialog: {
        show: false,
        mode: 'info', // 'info' | 'confirm'
        title: '',
        oldPrice: 0,
        newPrice: 0,
        packageTitle: '',
        _resolve: null
      },
      crrUser: null,
      couponCode: '',
      couponLoading: false,
      couponMessage: '',
      couponMessageType: '',
      appliedCoupon: null,
      instructingPlateNumber: '',
      independent: false,
      foundData: false,
      // Bounds for Ontario, Canada – used to bias address autocomplete to Ontario only
      ontarioBounds: {
        south: 41.67,
        north: 56.85,
        west: -95.15,
        east: -74.32
      },
      addressError: '',
      hasValidOntarioAddress: false,
      addressSelectionJustAccepted: false,
      populateCities: null,
      filteredCityEntries: [],
      populateSchools: null,
      filteredSchoolsEntries: [],
      ...validationRules,
      passwordRules: [
        (v) => !!v || 'Please type password.',
        (v) => (v && v.length >= 6) || 'minimum 6 characters'
      ],
      confirmPasswordRules: [
        (v) => !!v || 'Type confirm password',
        (v) =>
          v === this.password || 'The password confirmation does not match.'
      ]
    }
  },
  computed: {
    otpCountdownLabel() {
      const m = Math.floor(this.otpCountdown / 60)
      const s = this.otpCountdown % 60
      return `${m}:${s < 10 ? '0' : ''}${s}`
    },
    instructorData() {
      return {
        userType: this.userType,
        firstName: this.firstName,
        lastName: this.lastName,
        birthDate: this.birthDate,
        email: this.email,
        phone: this.phone,
        phoneNumberValid: false,
        phoneVerify: this.isPhoneVerify,
        password: this.password,
        drivingLicensePreview: this.drivingLicensePreview,
        instructorLicensePreview: this.instructorLicensePreview,
        addressOne: this.schoolAddress.addressOne,
        addressTwo: this.schoolAddress.addressTwo,
        country: this.schoolAddress.country,
        province: this.schoolAddress.province,
        city: this.schoolAddress.city,
        postalCode: this.schoolAddress.postalCode,
        selectCities: this.selectCities,
        address: this.address,
        instructorCityPlat: this.instructorCityPlat, // {cityName,fileName,fileUrl}
        operateModel: this.operateModel, // driverx , operate-independently
        schoolId: this.schoolId, // if operateNodel === false else ''
        schoolData: {
          schoolAddress: this.schoolAddress,
          schoolName: this.schoolName,
          schoolContactNumber: this.schoolContactNumber,
          schoolEmail: this.schoolEmail || ''
          /* addressOne: this.schoolAddress.addressOne,
          addressTwo: this.schoolAddress.addressTwo,
          city: this.schoolAddress.city,
          province: this.schoolAddress.province,
          postalCode: this.schoolAddress.postalCode,
          country: this.schoolAddress.country */
        }
      }
    },
    avatarButtonText() {
      return this.avatar ? this.avatar.name : 'Select Avatar'
    },
    filteredCities() {
      return this.filteredCityEntries
    },
    filteredSchools() {
      return this.filteredSchoolsEntries
    },
    packageDiscountEndMs () {
      const pkg = this.packageData
      if (!pkg) return 0
      const end = pkg.discountEnd
      if (!end) return 0
      if (end instanceof Date) return end.getTime()
      if (typeof end === 'number') return end
      if (typeof end === 'string') {
        const t = new Date(end).getTime()
        return isNaN(t) ? 0 : t
      }
      if (end.iso) {
        const t = new Date(end.iso).getTime()
        return isNaN(t) ? 0 : t
      }
      return 0
    },
    isPackageDiscountActive () {
      const pkg = this.packageData
      if (!pkg || pkg.discounted !== true) return false
      return this.packageDiscountEndMs > this.nowTs
    },
    packageDiscountCountdown () {
      const endMs = this.packageDiscountEndMs
      let diff = Math.max(0, Math.floor((endMs - this.nowTs) / 1000))
      const h = Math.floor(diff / 3600)
      diff -= h * 3600
      const m = Math.floor(diff / 60)
      const s = diff - m * 60
      const pad = (n) => String(n).padStart(2, '0')
      return { h: pad(h), m: pad(m), s: pad(s) }
    },
    packageSavings () {
      const pkg = this.packageData
      if (!this.isPackageDiscountActive || !pkg.originalPrice) return 0
      return Math.max(0, Math.round(pkg.originalPrice - pkg.price))
    },
    packageSavePercent () {
      const pkg = this.packageData
      if (!this.isPackageDiscountActive || !pkg.originalPrice) return 0
      return Math.round(((pkg.originalPrice - pkg.price) / pkg.originalPrice) * 100)
    },
    ...mapGetters(['user', 'schools'])
  },
  mounted () {
    this._discountTickInterval = setInterval(() => {
      this.nowTs = Date.now()
    }, 1000)
  },
  beforeDestroy () {
    if (this._discountTickInterval) clearInterval(this._discountTickInterval)
    if (this.otpTimerHandle) clearInterval(this.otpTimerHandle)
  },
  watch: {
    isPackageDiscountActive (active, wasActive) {
      // Live expiry: discount was running, now it's not. Notify user once and revert price.
      if (wasActive && !active && !this._discountExpiredHandled) {
        this._discountExpiredHandled = true
        const pkg = this.packageData
        if (pkg && pkg.originalPrice) {
          const oldPrice = pkg.price
          pkg.price = pkg.originalPrice
          pkg.discounted = false
          this.$nextTick(() => {
            this.openDiscountDialog({
              mode: 'info',
              title: 'Limited-time discount has ended',
              oldPrice,
              newPrice: pkg.originalPrice,
              packageTitle: pkg.title || 'this package'
            })
          })
        }
      }
    },
    populateCities(value) {
      value.length && (this.filteredCityEntries = selectedCities)
    },
    populateSchools (value) {
      value.length && (this.filteredSchoolsEntries = value)
    },
    // progressDialog (val) {
    //   if (!val) return
    // },
    avatarPreview() {
      this.loadingPreview = false
    },
    schools(value) {
      if (value.length) {
        this.filteredSchoolsEntries = value
      }
    },
    croppedImage(val) {
      if (val) {
        this.uploadEditFileToParseServer(val)
      }
    }
  },
  methods: {
    ...mapActions(['toggleDialog', 'getSchools', 'showToast', 'sendSMS']),
    openDiscountDialog (opts) {
      // Returns a promise that resolves with `true` (proceed) or `false` (cancel).
      // For 'info' mode, only the proceed button is shown.
      return new Promise((resolve) => {
        this.discountDialog = {
          show: true,
          mode: opts.mode || 'info',
          title: opts.title || '',
          oldPrice: opts.oldPrice != null ? opts.oldPrice : 0,
          newPrice: opts.newPrice != null ? opts.newPrice : 0,
          packageTitle: opts.packageTitle || '',
          _resolve: resolve
        }
      })
    },
    closeDiscountDialog (proceed) {
      const resolve = this.discountDialog._resolve
      this.discountDialog.show = false
      this.discountDialog._resolve = null
      if (resolve) resolve(!!proceed)
    },
    // showInsert () {
    //   const RegisterSchools = Parse.Object.extend('RegisterSchools')
    //   const query = new RegisterSchools()
    //   query.set('name', 'best driving school')
    //   query.set('address', '')
    //   query.set('phone', '')
    //   query.set('schoolId', 'ALLlieCwqJ')
    //   query.set('location', { lat: 44.3425913959443, lng: -78.80153631155984 })
    //   const acl = new Parse.ACL()
    //   acl.setPublicReadAccess(true)
    //   acl.setPublicWriteAccess(true)
    //   query.setACL(acl)
    //   return query.save({}, { useMasterKey: true })
    //     .then(entry => {
    //       console.log('done')
    //     })
    // },
    selectHearAbout(value) {
      this.heardAboutUs = value
    },
    async hearAboutContinue() {
      /** Store the answer on the student, then move on to checkout */
      this.hearAboutSaving = true
      const heardSource =
        this.heardAboutUs === 'Other' && this.heardAboutUsOther.trim()
          ? 'Other: ' + this.heardAboutUsOther.trim()
          : this.heardAboutUs
      await Parse.Cloud.run('saveHeardAboutUs', {
        studentId: this.crrUser.id,
        source: heardSource
      }).catch((e) => console.log('saveHeardAboutUs failed:', e.message))
      this.hearAboutSaving = false
      this.step = 5
    },
    async handleCheckout(event) {
      event.preventDefault()
      try {
        console.log(
          'Calling Checkout Session API  email - ',
          this.crrUser.get('email')
        )

        // Calculate the correct price with discount and tax applied
        let calculatedPrice = 0

        if (this.paramPriceId) {
          // If split payment (paramPriceId exists), use fixed price of 124.07
          let basePrice = 124.07

          // Apply coupon discount if available
          if (this.appliedCoupon) {
            basePrice = basePrice * (1 - this.appliedCoupon.discount / 100)
          }

          calculatedPrice = this.packageData.taxApplicable
            ? basePrice + (basePrice * 0.13)
            : basePrice
        } else {
          // Re-check whether the package discount is still active right now.
          // If it has expired during signup, notify the user and fall back to originalPrice.
          let basePackagePrice = this.packageData.price
          const end = this.packageData.discountEnd
          let endMs = 0
          if (end) {
            if (end instanceof Date) endMs = end.getTime()
            else if (typeof end === 'number') endMs = end
            else if (typeof end === 'string') endMs = new Date(end).getTime()
            else if (end.iso) endMs = new Date(end.iso).getTime()
          }
          const wasDiscounted = this.packageData.discounted === true
          const stillDiscounted = wasDiscounted && endMs > Date.now()

          if (wasDiscounted && !stillDiscounted && this.packageData.originalPrice) {
            const proceed = await this.openDiscountDialog({
              mode: 'confirm',
              title: 'Limited-time discount has ended',
              oldPrice: this.packageData.price,
              newPrice: this.packageData.originalPrice,
              packageTitle: this.packageData.title || 'this package'
            })
            if (!proceed) {
              return
            }
            basePackagePrice = this.packageData.originalPrice
            this.packageData.price = this.packageData.originalPrice
            this.packageData.discounted = false
          }

          // Apply legacy discountPercentage (if any) on top — harmless when 0/undefined
          let discountedPrice = Math.round(basePackagePrice * (1 - (this.packageData.discountPercentage || 0) / 100))

          // Apply coupon discount if available
          if (this.appliedCoupon) {
            discountedPrice = discountedPrice * (1 - this.appliedCoupon.discount / 100)
          }

          // Apply tax if applicable
          calculatedPrice = this.packageData.taxApplicable
            ? discountedPrice + (discountedPrice * 0.13)
            : discountedPrice
        }

        console.log('calculatedPrice with discount and tax:', calculatedPrice)

        const response = await axios.post(
          '/create-checkout-session',
          {
            name: this.packageData.title || 'Package',
            price: calculatedPrice,
            packageId: this.paramPackageValue,
            userId: this.crrUser.id,
            schoolId: this.packageData?.schoolId?.objectId,
            prePaid: this.packageData?.prePaid,
            email: this.crrUser.get('email'),
            priceId: this.paramPriceId,
            couponCode: this.appliedCoupon ? this.appliedCoupon.code : null,
            couponDiscount: this.appliedCoupon ? this.appliedCoupon.discount : null
          },
          {
            headers: {
              'X-Parse-Application-Id':
                '71237DFB8FA1D83A3363EB45CF0B4AC7BD44E1EA'
            }
          }
        )

        console.log(
          'Calling Checkout Session API response ===  ',
          response.data
        )
        const sessionId = response.data.id
        if (sessionId) {
          console.log('session id ===', sessionId)

          const checkoutUrl = response.data.url || `https://checkout.stripe.com/c/pay/${sessionId}`

          // Check if running on mobile (Cordova)
          if (typeof window.cordova !== 'undefined') {
            console.log('📱 Mobile: Opening checkout in Safari')
            window.open(checkoutUrl, '_blank')
          } else {
            console.log('🌐 Web: Using Stripe.js redirect')
            const PUBLISHABLE_KEY = 'pk_live_51Hca9mL9XL9PNUheZERE3glh8mHxefAHqRy4MOcTQE5irYCbhkOHGXx8Nk7Tcr51dMnS01RUA0JJUDs8UbvYlp0b00SLCtH4Lk'
            // const PUBLISHABLE_KEY = 'pk_test_51Hca9mL9XL9PNUhe1FYfznWfUIlyz3IljTmx9etbCin5rUPgvyQLO6QXOyuke5Job8PtBHCZ3y72uULizi2ZNveL00NjBgKKjQ'
            const stripe = await loadStripe(PUBLISHABLE_KEY)
            await stripe.redirectToCheckout({ sessionId })
          }
        }
      } catch (error) {
        console.error('Error creating Stripe checkout session:', error)
      }
    },
    onInput (formattedNumber, { number, valid, country }) {
      this.phone = number.e164
      this.phoneNumberValid = valid
    },
    submitValidateStepFour() {
      const validate = this.$refs.signupFormStepCityPlatEmail.validate()
      if (this.isEmailExist) {
        this.toggleDialog({
          status: true,
          title: 'Warning',
          message: 'Email already registered'
        })
      }
      if (validate && !this.isEmailExist) {
        this.step = 3222
      }
    },
    async validateStepThree() {
      const formValid = this.$refs.signupFormStep11.validate()
      // Driving license is optional for students, so we don't check for it here
      // if (this.drivingLicensePreview.length === 0) {
      //   this.toggleDialog({
      //     status: true,
      //     title: 'Warning',
      //     message: 'Please upload driving license'
      //   })
      // }
      // if (this.instructorLicensePreview.length === 0) {
      //   this.toggleDialog({
      //     status: true,
      //     title: 'Warning',
      //     message: 'Please upload instructing license'
      //   })
      // }
      if (this.phoneNumberValid === false) {
        this.toggleDialog({
          status: true,
          title: 'Warning',
          message: 'Phone Number is not valid'
        })
      }
      /** Hard stop: passwords must match before any account/OTP action */
      if (this.userType === 'Student' && this.password !== this.confirmPassword) {
        this.toggleDialog({
          status: true,
          title: 'Warning',
          message: "Passwords don't match. Please re-enter the same password in both fields."
        })
        return
      }
      /** Hard stop: a valid Ontario address must be selected from the suggestions */
      if (this.userType === 'Student' && !this.hasValidOntarioAddress) {
        this.toggleDialog({
          status: true,
          title: 'Warning',
          message: 'Please select a valid Ontario address from the address suggestions.'
        })
        return
      }
      const elements = this.$refs.signupFormStep11.$el.elements
      if (
        formValid &&
        customValidate(elements) &&
        this.phoneNumberValid
      ) {
        this.$refs.phoneVerificationButton.$el.innerHTML = 'Please wait ...'
        /** One account per phone number for NEW signups — disabled for now.
            Uncomment to block signups with an already-registered phone number. */
        // if (!this.crrUser) {
        //   try {
        //     const existingPhone = await new Parse.Query('_User')
        //       .equalTo('phone', this.phone)
        //       .first({ useMasterKey: true })
        //     if (existingPhone) {
        //       this.$refs.phoneVerificationButton.$el.innerHTML = 'Continue'
        //       this.toggleDialog({
        //         status: true,
        //         title: 'Phone Number Already Registered',
        //         message:
        //           'This phone number is already linked to an existing DriverX account. Please use a different phone number, or log in to your existing account instead.'
        //       })
        //       return
        //     }
        //   } catch (e) {
        //     console.log('Phone check failed = ', e)
        //   }
        // }
        if (this.userType === 'Student') {
          /** Create the account first so the lead is in our system, then spend the OTP */
          this.createStudentAccount().then((created) => {
            if (created) {
              this.verifyPhoneNumber()
            } else {
              this.$refs.phoneVerificationButton.$el.innerHTML = 'Continue'
            }
          })
        } else {
          this.verifyPhoneNumber()
        }
      }
    },
    async createStudentAccount() {
      /** Already created (e.g. OTP resend) — don't sign up twice */
      if (this.crrUser) {
        return true
      }
      const user = new Parse.User()
      user.set('firstName', this.firstName)
      user.set('lastName', this.lastName)
      user.set('username', this.email)
      user.set('password', this.password)
      user.set('customEmail', this.email)
      user.set('email', this.email)
      user.set('phone', this.phone)
      user.set('city', this.city)
      user.set('addressOne', this.address)
      user.set('profileNotCompleted', false)
      user.set('status', true)
      if (this.paramPackageValue) {
        user.set('packageId', this.paramPackageValue)
        if (this.packageData.onSignupPay) {
          user.set('pre_paid', false)
        } else {
          /** If Package is not PrePaid then there No Need to set pre_paid in user faklse bcz that makes issue while login */
          user.set('pre_paid', true)
        }
      }
      try {
        await user.signUp()
        this.crrUser = user
        /** Lead capture right away: mailchimp + Student role (reminders depend on the role) */
        Parse.Cloud.run('addContactToMailChimp', {
          firstName: this.firstName || '',
          lastName: this.lastName || '',
          email: this.email,
          phone: this.phone
        }).catch((error) => console.log(error))
        await Parse.Cloud.run('addUserToRole', {
          user: user.id,
          accountname: 'Student',
          admin: false
        }).catch((error) => console.log(error))
        return true
      } catch (e) {
        console.log('Error creating student account = ', e)
        this.alertMessage = e.message
        this.errorDialogModal = true
        return false
      }
    },
    async notifyAdminNewStudent() {
      /** Runs once, right after the OTP is verified: alert admin (SMS + email)
          and pre-associate the student with the school so they show up on the
          school panel immediately — not only after the last signup step */
      if (this.userType !== 'Student' || this.adminNotified || !this.crrUser) {
        return
      }
      this.adminNotified = true

      /** Mark the phone as verified on the account right away */
      try {
        this.crrUser.set('phoneVerify', true)
        await this.crrUser.save()
      } catch (e) {
        console.log('Error saving phoneVerify = ', e)
      }

      /** Let the admin know (same message that used to go out at the end) */
      const message =
        this.firstName +
        ' ' +
        this.lastName +
        ' just signed up as Student from the city of ' +
        this.city +
        ', ' +
        this.province +
        '. Contact number is ' +
        this.phone + ' ' +
        'with package :' +
        (this.packageData?.title || 'No Package')

      try {
        Parse.Cloud.run('sendSMS', { message: message }).then(() => {
          console.log('SMS successful')
        })
      } catch (error) {
        console.log('Error in sending SMS =', error)
      }

      /** Send an email as well */
      Parse.Cloud.run('newUserJoined', {
        contact:
          'city of ' +
          this.city +
          ', ' +
          this.province +
          ' and cell# ' +
          this.phone,
        type: 'Student',
        name: this.firstName + ' ' + this.lastName
      }).then(() => {
        console.log('Email successful')
      })

      /** Pre-associate with the school so the student is visible on the school side now */
      if (this.packageData) {
        await this.addSchoolPackageJoined({
          schoolId: this.packageData?.schoolId?.objectId,
          schoolPackageId: this.packageData.objectId,
          studentId: this.crrUser.id,
          prePaid: this.packageData.prePaid
        })
      }
    },
    startOtpTimer() {
      /** 5-minute client-side validity window shown as a live countdown */
      this.otpError = ''
      this.phoneCode = ''
      this.otpCountdown = 300
      clearInterval(this.otpTimerHandle)
      this.otpTimerHandle = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--
        } else {
          clearInterval(this.otpTimerHandle)
        }
      }, 1000)
    },
    stopOtpTimer() {
      clearInterval(this.otpTimerHandle)
    },
    closeOtpDialog() {
      /** Keep the countdown running — the sent code stays valid, so reopening
          the dialog must not trigger another SMS */
      this.isPhoneNumberPopup = false
    },
    verifyPhoneNumber() {
      if (this.phone.length !== 0) {
        /** A code for this number is still valid — reopen the dialog, don't resend */
        if (this.otpCountdown > 0 && this.otpSentToPhone === this.phone) {
          this.otpError = ''
          this.isPhoneNumberPopup = true
          this.$refs.phoneVerificationButton.$el.innerHTML = 'Continue'
          return
        }
        Parse.Cloud.run('phone-number-verification', {
          phone: `${this.phone}`
        })
          .then((result) => {
            if (result.success === true) {
              this.otpSentToPhone = this.phone
              this.isPhoneNumberPopup = true
              this.startOtpTimer()
              this.$refs.phoneVerificationButton.$el.innerHTML = 'Continue'
            } else if (result.rateLimited) {
              this.toggleDialog({
                status: true,
                title: 'Please wait',
                message: result.message
              })
              this.$refs.phoneVerificationButton.$el.innerHTML = 'Continue'
            }
          })
          .catch((error) => {
            this.$refs.phoneVerificationButton.$el.innerHTML = 'Continue'
            console.log(error, 'Error')
          })
      }
    },
    phoneVerificationSubmit() {
      if (this.otpCountdown === 0) {
        this.otpError = 'This code has expired. Close this window and tap Continue to receive a new code.'
        return
      }
      if (!this.phoneCode || !this.phoneCode.trim()) {
        this.otpError = 'Please enter the verification code from the SMS.'
        return
      }
      this.$refs.verifyPhoneNumberButton.$el.innerHTML = 'Please wait ...'
      // Bypass code: accept OTP and proceed to next step
      if (this.phoneCode === '7861') {
        this.stopOtpTimer()
        this.isPhoneNumberPopup = false
        this.isPhoneVerify = true
        this.notifyAdminNewStudent()
        this.step = this.userType === 'Student' ? 4 : 6 // move to step 4 for school
        this.$refs.verifyPhoneNumberButton.$el.innerHTML = 'Verify'
        return
      }
      Parse.Cloud.run('verifyPhoneNumber', {
        phone: `${this.phone}`,
        code: this.phoneCode
      })
        .then((result) => {
          console.log(result, 'result')
          if (result.success) {
            this.stopOtpTimer()
            this.isPhoneNumberPopup = false
            this.isPhoneVerify = true
            this.notifyAdminNewStudent()
            this.step = this.userType === 'Student' ? 4 : 6 // move to step 4 for school
            this.$refs.verifyPhoneNumberButton.$el.innerHTML = 'Verify'
          } else {
            this.otpError = 'The code you entered is incorrect or has already expired. Please check the SMS and try again.'
            this.$refs.verifyPhoneNumberButton.$el.innerHTML = 'Verify'
          }
        })
        .catch((error) => {
          this.otpError = 'We could not verify the code right now. Please try again.'
          this.$refs.verifyPhoneNumberButton.$el.innerHTML = 'Verify'
          console.log(error)
        })
    },
    dialogCloseHandle() {
      this.showLastStep = false
      this.$router.push('login')
    },
    moveToLastStepHandle(data) {
      this.showLastStep = data
      console.log(data, 'last step')
    },
    SchoolSelectedDBSchool(school) {
      this.isSelectSchool = true
      this.schoolId = school.schoolId
      console.log(school, 'school')
    },
    SchoolSelectedHandle(data) {
      this.isSelectSchool = data.isSelectSchool
      this.schoolAddress = data.address
      this.schoolName = data.name
      this.schoolContactNumber = data.phone
      this.schoolId = data.schoolId
      this.operateModel = data.isOperateIndefendent
      console.log(data, 'SignupForm')
    },
    emailHandleExist(e) {
      if (this.step === 3 && this.userType === 'Instructor') {
        if (this.email !== '' && isValidEmail(this.email)) {
          const User = new Parse.Query('_User')
          User.equalTo('email', this.email)
          User.find()
            .then((result) => {
              if (result.length > 0) {
                this.isEmailExist = true
                this.showToast({
                  isOpen: true,
                  text: 'Email Address already exist...'
                })
              } else {
                this.isEmailExist = false
              }
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.isEmailExist = true
        }
      }
      if (this.step === 3 && this.userType === 'Student') {
        if (this.email !== '' && isValidEmail(this.email)) {
          const User = new Parse.Query('_User')
          User.equalTo('email', this.email)
          User.find({ useMasterKey: true })
            .then((result) => {
              if (result.length > 0) {
                this.isEmailExist = true
                this.showToast({
                  isOpen: true,
                  text: 'Email Address already exist...'
                })
              } else {
                this.isEmailExist = false
              }
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.isEmailExist = true
        }
      }
    },
    cityPlatUploadSubmit(data) {
      console.log(data)
      this.instructorCityPlat.push(data)
    },
    deleteTagHandle(e, index, city) {
      this.selectCities.splice(index, 1)
      document.getElementById(`select-city-${city}`).checked = false
      this.$forceUpdate()
    },
    selectCitiesHandle(e) {
      const { value, checked } = e.target
      const i = removeDuplicateItem(this.selectCities, '', value)
      if (checked) {
        if (i === -1) {
          if (this.selectCities.length < 5) {
            this.selectCities.push(value)
          } else {
            document.getElementById(`select-city-${value}`).checked = false
            this.showToast({
              isOpen: true,
              text: 'Maximum five city are allowed.',
              timeout: 2000
            })
          }
        } else {
          this.selectCities[i] = value
        }
      } else {
        if (i !== -1) {
          this.selectCities.splice(i, 1)
        }
      }
      this.citySearch = ''
      this.dropdownCities = []
      this.$forceUpdate()
    },
    loadCitiesHandle() {
      const instance = this
      instance.dropdownCities = []
      setTimeout(async () => {
        instance.dropdownCities = []
        if (instance.citySearch.length > 0) {
          const Cities = new Parse.Query('Cities')
          Cities.equalTo('country_code', instance.country)
          Cities.equalTo('state_code', instance.province)
          Cities.startsWith(
            'city_name',
            `${instance.citySearch.toLowerCase()}`
          )
          instance.dropdownCities = []
          await Cities.find().then((results) => {
            results.map((row, index) => {
              const { attributes } = row
              const i = removeDuplicateItem(
                instance.dropdownCities,
                'text',
                attributes.city_name
              )
              if (i === -1) {
                instance.dropdownCities.push({
                  text: attributes.city_name,
                  value: attributes.city_name
                })
              }
            })
          })
        } else {
          instance.dropdownCities = []
        }
      }, 800)
    },
    loadStateHandle() {
      this.states = []
      this.citySearch = ''
      this.dropdownCities = []
      const States = new Parse.Query('States')
      States.equalTo('country_code', this.country)
      States.find().then((results) => {
        if (this.country === 'US') {
          this.states.push({ text: 'Select a State', value: '' })
        } else {
          this.states.push({ text: 'Select a Province', value: '' })
        }
        results.map((row, index) => {
          const { attributes } = row
          this.states.push({
            text: attributes.state_name,
            value: attributes.state_code
          })
        })
      })
    },
    getCountries() {
      this.citySearch = ''
      this.dropdownCities = []
      this.countries.push({ text: 'Select a Country', value: '' })
      this.countries.push({ text: 'Canada', value: 'CA' })
      this.countries.push({ text: 'USA', value: 'US' })
      // const countries = new Parse.Query('Countries')
      // await countries.find().then(async (results) => {
      //   this.countries.push({ text: 'Select a Country', value: '' })
      //   results.map((row, index) => {
      //     const { attributes } = row
      //     this.countries.push({ text: attributes.country_name, value: attributes.code })
      //   })
      // })
    },
    async init() {
      await this.getSchools()
      if (this.schools) {
        this.filteredSchoolsEntries = this.schools
        console.log(this.schools)
      }
    },
    onStudentAddressInput(value) {
      if (this.addressSelectionJustAccepted) {
        this.addressSelectionJustAccepted = false
        return
      }
      const trimmed = (value !== null && value !== undefined ? String(value) : '').trim()
      if (trimmed && this.address && trimmed === this.address.trim()) return
      this.hasValidOntarioAddress = false
    },
    getSchoolAddressDataCity(addressData) {
      console.log(addressData)
      // Student signup: only allow Ontario addresses
      if (this.userType === 'Student') {
        const province = addressData.administrative_area_level_1 || addressData.province || ''
        const formatted = (addressData.formatted_address || '').toLowerCase()
        const hasOntarioInAddress = /, on\b|, ontario\b|\bontario\b/.test(formatted)
        const isOntario =
          /ontario|on\b/i.test(province) ||
          addressData.administrative_area_level_1_short === 'ON' ||
          hasOntarioInAddress
        if (!isOntario) {
          this.hasValidOntarioAddress = false
          this.addressError = 'Only Ontario cities or addresses are allowed.'
          this.toggleDialog({
            status: true,
            title: 'Invalid address',
            message: 'Only Ontario cities or addresses are allowed.'
          })
          this.address = ''
          this.city = ''
          this.postalCode = ''
          this.province = ''
          this.country = ''
          this.$nextTick(() => {
            if (this.$refs.address11Student && this.$refs.address11Student.clear) {
              this.$refs.address11Student.clear()
            }
          })
          return
        }
      }
      this.addressError = ''
      if (this.userType === 'Student') {
        this.hasValidOntarioAddress = true
        this.addressSelectionJustAccepted = true
      }
      const {
        name,
        postal_code: postalCodeVal,
        locality,
        country,
        administrative_area_level_1: adminArea1
      } = addressData
      // Build address string without undefined (avoids sending literal "undefined" in payload)
      const addressParts = [
        name,
        locality,
        adminArea1,
        postalCodeVal,
        country
      ].filter(p => p !== null && p !== '')
      this.address = addressParts.join(', ').trim() || ''
      this.addressOne = addressData.name || ''
      this.postalCode = addressData.postal_code || ''
      // City: use locality, fallback to sublocality or administrative_area_level_2
      this.city = addressData.locality || addressData.city || addressData.sublocality || addressData.administrative_area_level_2 || ''
      this.province = addressData.administrative_area_level_1 || ''
      this.country = addressData.country || ''
      this.latitude = addressData.latitude
      this.longitude = addressData.longitude
      console.log(addressData, 'addressData')
      // Re-apply valid state after next tick so it isn't overwritten by @input from autocomplete
      if (this.userType === 'Student') {
        this.$nextTick(() => {
          this.hasValidOntarioAddress = true
        })
      }
    },
    getSchoolAddressData(addressData) {
      /* this.addressOne = addressData.name
      this.postalCode = addressData.postal_code
      this.city = addressData.locality
      this.province = addressData.administrative_area_level_1
      this.country = addressData.country
      this.latitude = addressData.latitude
      this.longitude = addressData.longitude
      console.log(addressData, 'addressData') */
      this.schoolAddress = {
        addressOne: this.addressTwo,
        addressTwo: addressData.name,
        city: addressData.locality,
        province: addressData.administrative_area_level_1,
        postalCode: addressData.postal_code,
        country: addressData.country
      }
      console.log(this.schoolAddress, 'school address')
      this.foundData = true
    },
    async submitStudent() {
      const self = this
      console.log(self.userType)
      self.progressDialog = true
      self.editable = false
      self.loading = true
      if (self.$refs.signupFormStep1.validate()) {
        /** Account exists since step 3 and admin was notified after the OTP —
            here we only complete the remaining profile data */
        const user = this.crrUser || Parse.User.current()
        user.set('uploadLicence', self.drivingLicensePreview)
        user.set('dob', new Date(self.birthDate))
        await user
          .save()
          .then(async () => {
            /** Set User to Global State  */
            this.crrUser = user

            self.progressDialog = false
            /* self.step = 3 */
            if (this.packageData) {
              /** Ask where they heard about us, then checkout */
              self.step = 7
            } else {
              self.step = 6
            }
            /** We don't want users to be logged in right now as they need to verify their email */
            Parse.User.logOut()
            /** Show success alert */
            console.log('Success')
            localStorage.setItem('regDone', true)
          })
          .catch((e) => {
            console.log('Error on Submit Studet = ', e)
            self.progressDialog = false
            self.alertMessage = e.message
            self.errorDialogModal = true
            self.editable = true
          })
      } else {
        self.progressDialog = false
        self.errorDialogModal = true
        self.editable = true
      }
      this.loading = false
    },
    async addSchoolPackageJoined({
      studentId,
      schoolId,
      schoolPackageId,
      prePaid
    }) {
      console.log('Adding School Package === studentId ', studentId)
      console.log('Adding School schoolId === ', schoolId)
      console.log('Adding School schoolPackageId === ', schoolPackageId)
      console.log('Adding School prePaid === ', prePaid)
      /** Check if this same records already saved, then just return the ID */
      const SchoolPackageJoined = Parse.Object.extend('SchoolPackageJoined')
      const query = new Parse.Query(SchoolPackageJoined)

      const User = Parse.Object.extend('User')
      const UserPointerId = new User()
      UserPointerId.id = studentId
      query.equalTo('studentId', UserPointerId)

      const Schools = Parse.Object.extend('Schools')
      const SchoolsPointerId = new Schools()
      SchoolsPointerId.id = schoolId
      query.equalTo('schoolId', SchoolsPointerId)

      const SchoolPackages = Parse.Object.extend('SchoolPackages')
      const SchoolPackagesPointerId = new SchoolPackages()
      SchoolPackagesPointerId.id = schoolPackageId
      query.equalTo('schoolPackageId', SchoolPackagesPointerId)

      try {
        const response = await query.first()
        if (response) {
          console.log('setSchoolPackageJoined', response.id)
        } else {
          var saveSchoolPackageJoined = new SchoolPackageJoined()
          saveSchoolPackageJoined.set('studentId', UserPointerId)
          saveSchoolPackageJoined.set('schoolId', SchoolsPointerId)
          saveSchoolPackageJoined.set(
            'schoolPackageId',
            SchoolPackagesPointerId
          )
          saveSchoolPackageJoined.set('pre_paid', JSON.parse(prePaid))
          saveSchoolPackageJoined.set('status', true)

          await saveSchoolPackageJoined.save().then(
            (saveSchoolPackageJoined) => {
              console.log('setSchoolPackageJoined', saveSchoolPackageJoined.id)
            },
            (error) => {
              console.log(error)
            }
          )
        }
      } catch (error) {
        console.log(error)
      }
    },
    async submit() {
      const self = this
      console.log(self.userType)
      self.progressDialog = true
      self.editable = false
      self.loading = true
      if (self.$refs.signupFormStep1.validate()) {
        /** Submit the form */
        const user = new Parse.User()
        user.set('firstName', self.firstName)
        user.set('lastName', self.lastName)
        user.set('username', self.email)
        user.set('password', self.password)
        user.set('customEmail', self.email)
        user.set('email', self.email)
        user.set('phone', self.phone)
        user.set('profileNotCompleted', true)
        user.set('dob', new Date(self.birthDate))
        if (self.userType === 'Instructor') {
          user.set('status', false)
        } else {
          user.set('status', true)
        }
        await user
          .signUp()
          .then(async () => {
            /** call the cloud fundtion to subscribe to mailchimp */
            const cData = {
              firstName: self.firstName || '',
              lastName: self.lastName || '',
              email: self.email,
              phone: self.phone
            }
            await Parse.Cloud.run('addContactToMailChimp', cData).then(
              (results) => {
                console.log(results)
              },
              (error) => {
                console.log(error)
              }
            )
            /** Add user to the user group */
            const data = {
              user: user.id,
              accountname:
                self.userType === 'Instructor' ? 'Instructor' : 'Student',
              admin: false
            }
            /** call the cloud fundtion */

            await Parse.Cloud.run('addUserToRole', data).then(() => {
              self.progressDialog = false
              /* self.step = 4 */
              self.step = 2
              /** We don't want users to be logged in right now as they need to verify their email */
              // Parse.User.logOut()
              /** Show success alert */
              console.log('Success')
              localStorage.setItem('regDone', true)
            })
          })
          .catch((e) => {
            self.progressDialog = false
            self.alertMessage = e.message
            self.errorDialogModal = true
            self.editable = true
          })
      } else {
        self.progressDialog = false
        self.errorDialogModal = true
        self.editable = true
      }
      this.loading = false
    },

    uploadAvatar(type) {
      this.avatarDialog = false
      if (type === 'Capture') {
        this.capture()
      } else {
        this.chooseFromLibrary()
      }
    },
    capture() {
      // Take picture using device camera and retrieve image as base64-encoded string
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, {
        quality: 65,
        allowEdit: window.device.platform !== 'Android',
        targetWidth: 350,
        targetHeight: 500,
        correctOrientation: true,
        destinationType: window.Camera.DestinationType.DATA_URL
      })
    },
    chooseFromLibrary() {
      console.log('chooseFromLibrary')
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      // this.$refs.fileUploader.click();

      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, {
        quality: 65,
        allowEdit: window.device.platform !== 'Android',
        targetWidth: 350,
        targetHeight: 500,
        correctOrientation: true,
        destinationType: window.Camera.DestinationType.DATA_URL,
        sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY,
        mediaType: window.Camera.MediaType.PICTURE
      })
    },
    async onPhotoEditDataSuccess(imageData) {
      // window.clearCache();
      this.uploadEditFileToParseServer(imageData)
    },
    async onPhotoDataSuccess(imageData) {
      this.uploadEditFileToParseServer(imageData)
    },
    onFail(e) {
      this.cleanup()
      this.isSelecting = false
      this.loadingPreview = false
      this.toggleDialog({
        status: true,
        title: 'Error',
        message: 'Upload failed' + JSON.stringify(e)
      })
    },
    cleanup() {
      navigator.camera.cleanup()
    },
    async uploadEditFileToParseServer(imageData) {
      this.isSelecting = false
      if (!this.isWeb) {
        this.cleanup()
      }
      var base64pic = 'data:image/jpeg;base64,' + imageData
      var parseFile = new Parse.File(Math.floor(Date.now() / 1000), {
        base64: this.isWeb ? imageData : base64pic
      })
      parseFile.addMetadata('tag', 'test')
      parseFile.addTag('textTag', 'some-group-id')
      await parseFile.save().then(
        () => {
          this.loadingPreview = false
          this.avatarURL = parseFile._url
          this.avatarPreview = parseFile._url
        },
        (error) => {
          this.loadingPreview = false
          console.log(JSON.stringify(error))
        }
      )
    },
    async reduce_image_file_size (base64Str, MAX_WIDTH = 450, MAX_HEIGHT = 450) {
      const resizedBase64 = await new Promise((resolve) => {
        const img = new Image()
        img.src = base64Str
        img.onload = () => {
          const canvas = document.createElement('canvas')
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL()) // this will return base64 image results after resize
        }
      })
      return resizedBase64
    },
    onAvatarChangeDrivingLicense (e) {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.drivingLicensePreview = reader.result
        const data = {
          base64: reader.result.toString('base64')
        }
        const timestamp = (new Date().getTime() / 1000)?.toFixed(0)
        const name = `drivinglicensePreview_${timestamp}.png`
        const parseFile = new Parse.File(name.toLowerCase(), data)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save({
            progress: (value) => {
              this.progressValue = value * 100
            }
          })
          .then((res) => {
            console.log(res, parseFile, 'then')
            this.drivingLicense = {
              name: parseFile._name,
              url: parseFile._url
            }
            this.drivingLicensePreview = parseFile._url
          })
          .catch((error) => {
            console.log(error?.message, error.code, 'Error')
          })
      }
      reader.onerror = (error) => {
        console.error(error)
      }
      // }
    },
    onAvatarChangeInstructorLicense(e) {
      console.log('Here')
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.instructorLicensePreview = reader.result
        const data = {
          base64: reader.result.toString('base64')
        }
        const timestamp = (new Date().getTime() / 1000)?.toFixed(0)
        const name = `instructorLicensePreview_${timestamp}.png`
        const parseFile = new Parse.File(name.toLowerCase(), data)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save({
            progress: (value) => {
              this.progressValueIL = value * 100
            }
          })
          .then((res) => {
            console.log(res, parseFile, 'then')
            this.instructorLicense = {
              name: parseFile._name,
              url: parseFile._url
            }
            this.instructorLicensePreview = parseFile._url
          })
          .catch((error) => {
            console.log(error?.message, error.code, 'Error')
          })
      }
      reader.onerror = (error) => {
        console.error(error)
      }
      // }
    },
    onAvatarChange() {
      this.loadingPreview = true
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   console.log(e.target.result);
      //   this.avatarPreview = e.target.result;
      // };

      if (this.avatar) {
        if (this.isWeb) {
          const reader = new FileReader()
          reader.readAsDataURL(this.avatar)
          reader.onload = () => {
            this.imgBlob = reader.result
            this.cropDialog = true
          }
          reader.onerror = (error) => {
            console.error(error)
          }
          return
        }
        // reader.readAsDataURL(this.avatar);
        /** Upload the file to the cloud and get the URL */
        let name = this.avatar.name
        name = name.replace(/[ ,]+/g, '-')
        const parseFile = new Parse.File(name, this.avatar)
        parseFile.addMetadata('tag', 'test')
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save()
          .then(() => {
            console.log(parseFile)
            this.avatarURL = parseFile._url
            this.avatarPreview = parseFile._url
          })
          .catch(console.log)
      } else {
        this.avatarPreview = null
      }
    },
    onLicenceChange() {
      // const reader = new FileReader();
      if (this.licence) {
        /** Upload the file to the cloud and get the URL */
        var name = this.licence.name
        name = name.replace(/[ ,]+/g, '-')
        var parseFile = new Parse.File(name, this.licence)
        parseFile.addMetadata('tag', 'test')
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save()
          .then(() => {
            this.licenceURL = parseFile._url
            console.log(this.licenceURL)
          })
          .catch(console.log)
      }
    },
    onInstructorLicenceChange() {
      // const reader = new FileReader();
      if (this.instructorLicence) {
        /** Upload the file to the cloud and get the URL */
        var name = this.instructorLicence.name
        name = name.replace(/[ ,]+/g, '-')
        var parseFile = new Parse.File(name, this.instructorLicence)
        parseFile.addMetadata('tag', 'test')
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save()
          .then(() => {
            this.instructorLicenceURL = parseFile._url
            console.log(this.instructorLicenceURL)
          })
          .catch(console.log)
      }
    },
    goToLogin() {
      localStorage.setItem('regDone', true)
      this.$router.push({ name: 'Login' })
      // window.location.reload();
    },
    async fetchPackageData(packageId) {
      const SchoolPackages = Parse.Object.extend('SchoolPackages')
      const query = new Parse.Query(SchoolPackages)

      // Assuming packageId is a unique identifier in the collection
      query.equalTo('objectId', packageId)

      try {
        const result = await query.first()
        return result ? result.toJSON() : null
      } catch (error) {
        console.error('Error while fetching package data:', error)
        return null
      }
    },
    async selectPackage(packageData) {
      console.log('Package value on signup form:', packageData)
      this.paramType = 'student'
      this.paramPackageValue = packageData?.objectId
      this.packageValue = packageData?.objectId
      var priceId = packageData?.priceId
      var packageId = packageData?.objectId
      // Preserve the discount metadata + effective price from the emit before re-fetching.
      const emitted = packageData || {}
      console.log('priceId on signup form :', packageData?.priceId)
      if (packageId) {
        console.log('Select package inside if ==')
        console.log('Package id inside if ==', packageId)
        const fetched = await this.fetchPackageData(packageId)
        console.log('Package data after fecthing  = ', fetched)
        if (fetched) {
          // Merge: fetched gives us schoolId / packageDetails / etc.,
          // but the discount-aware fields from the emit (effective price, discountEnd, etc.)
          // win so the order summary and checkout charge the discounted amount.
          const merged = {
            ...fetched,
            originalPrice: emitted.originalPrice != null ? emitted.originalPrice : fetched.price,
            effectivePrice: emitted.effectivePrice != null ? emitted.effectivePrice : fetched.price,
            discounted: emitted.discounted === true,
            discountEnd: emitted.discountEnd != null ? emitted.discountEnd : fetched.discountEnd,
            // Use the effective (already-discounted) price as the display/checkout price.
            price: emitted.price != null ? emitted.price : fetched.price
          }
          console.log('packageData in selectPackage (merged):', merged)
          this.packageData = merged
          this.paramPriceId = priceId
          // Reset expiry-notification guard for the newly selected package.
          this._discountExpiredHandled = false
        }
      }
      this.step = 3 // Move to the next step
    },
    async applyCoupon() {
      if (!this.couponCode.trim()) {
        this.showCouponMessage('Please enter a coupon code', 'error');
        return;
      }

      this.couponLoading = true;
      this.couponMessage = '';

      Parse.serverURL = 'https://thedriverx.com/parse'
      // Parse.serverURL = 'https://stage.thedriverx.appscorridor.com/parse'
      // Parse.serverURL = "http://localhost:1337/parse";

      try {
        const response = await axios.get(`${Parse.serverURL.replace('/parse', '')}/coupons/code/${this.couponCode.trim()}`);

        if (response.data && response.data.success) {
          const coupon = response.data.coupon;

          // Get current date and time
          const currentDate = new Date();

          // Check if coupon is valid from date (start date)
          if (coupon.validFrom) {
            const validFrom = new Date(coupon.validFrom);
            if (currentDate < validFrom) {
              this.showCouponMessage(`This coupon is not yet valid. Valid from ${this.formatDate(coupon.validFrom)}`, 'error');
              return;
            }
          }

          // Check if coupon has expired (end date)
          if (coupon.validUntil) {
            const validUntil = new Date(coupon.validUntil);
            if (currentDate > validUntil) {
              this.showCouponMessage(`This coupon has expired on ${this.formatDate(coupon.validUntil)}`, 'error');
              return;
            }
          }

          // Check if coupon is already applied
          if (this.appliedCoupon && this.appliedCoupon.code === coupon.code) {
            this.showCouponMessage('This coupon is already applied', 'info');
            return;
          }

          // Apply the coupon
          this.appliedCoupon = {
            code: coupon.code,
            discount: coupon.discountPercentage,
            description: coupon.description,
            validFrom: coupon.validFrom,
            expiryDate: coupon.validUntil
          }
          this.showCouponMessage(`Coupon applied successfully! You get ${coupon.discountPercentage}% off`, 'success')
          this.couponCode = ''
        } else {
          // Show the actual message from backend
          const errorMessage = response.data.message || 'Invalid coupon code';
          this.showCouponMessage(errorMessage, 'error');
        }
      } catch (error) {
        console.error('Error applying coupon:', error);
        // Try to extract error message from response if available
        let errorMessage = 'Error applying coupon. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.showCouponMessage(errorMessage, 'error');
      } finally {
        this.couponLoading = false;
      }
    },

    removeCoupon() {
      this.appliedCoupon = null;
      this.couponMessage = '';
      this.showCouponMessage('Coupon removed successfully', 'success');
    },

    showCouponMessage(message, type) {
      this.couponMessage = message;
      this.couponMessageType = type;

      // Auto-hide success messages after 3 seconds
      if (type === 'success') {
        setTimeout(() => {
          this.couponMessage = '';
        }, 3000);
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    calculateFinalTotal() {
      let basePrice = 0;

      if (this.paramPriceId) {
        // If split payment (paramPriceId exists), use fixed price of 124.07
        basePrice = 124.07;
      } else {
        // Apply package discount first
        basePrice = Math.round(this.packageData.price * (1 - (this.packageData.discountPercentage || 0) / 100));
      }

      // Apply coupon discount if available
      if (this.appliedCoupon) {
        basePrice = basePrice * (1 - this.appliedCoupon.discount / 100);
      }

      // Apply tax if applicable
      if (this.packageData.taxApplicable) {
        return (basePrice + (basePrice * 0.13)).toFixed(2);
      } else {
        return basePrice.toFixed(2);
      }
    },

    calculateCouponDiscount() {
      let basePrice = 0;

      if (this.paramPriceId) {
        basePrice = 124.07;
      } else {
        basePrice = Math.round(this.packageData.price * (1 - (this.packageData.discountPercentage || 0) / 100));
      }

      const discountAmount = basePrice * (this.appliedCoupon.discount / 100);
      return discountAmount.toFixed(2);
    },

    handleContinue(addressData) {
      // Store the address data from ZipCodeForm for later use
      this.userAddress = addressData

      // If you need specific address components separately
      if (addressData && addressData.components) {
        this.addressOne = addressData.components.addressOne || ''
        this.city = addressData.components.city || ''
        this.province = addressData.components.province || ''
        this.postalCode = addressData.components.postalCode || ''
        this.country = addressData.components.country || ''
      }

      // If you need coordinates
      if (addressData && addressData.coordinates) {
        this.latitude = addressData.coordinates.latitude
        this.longitude = addressData.coordinates.longitude
      }

      // Move to the next step
      // If package is already selected from URL, go directly to step 3 (license upload)
      if (this.packageData && this.paramPackageValue) {
        this.step = 3
      } else if (this.packageData) {
        console.log('packageData in handleContinue', this.packageData)
        this.step = 3
      } else {
        this.step = 2
      }

      // Add this debugging line:
      console.log('Step after handleContinue:', this.step)
      console.log('packageData:', this.packageData)
      console.log('paramPackageValue:', this.paramPackageValue)
    },
    handleBackButton() {
      if (this.step === 1) {
        this.$emit('setUserType', '')
      } else if (this.step === 3 && this.paramPackageValue) {
        // If we're on step 3 and have a package from URL, go back to step 1 (zipcode)
        this.step = 1
      } else {
        this.step--
      }
    }
  },
  async created() {
    this.getCountries()
    const packageValue = this.$route.query.package
    const type = this.$route.query.type
    const priceId = this.$route.query.priceId || null
    console.log('Package value on signup form:', packageValue)
    console.log('type on signup form :', type)
    console.log('priceId on signup form :', priceId)

    // Check if URL contains package parameter and type is student
    if (packageValue && type === 'student') {
      this.paramPackageValue = packageValue
      const packageData = await this.fetchPackageData(packageValue)
      console.log('Package data after fetching = ', packageData)

      if (packageData) {
        // Resolve discount from raw DB fields (discountPrice + discountEnd) so that
        // users landing here via the WordPress URL get the same discounted price
        // that the in-app PackagePlanBoxes flow would produce.
        const rawEnd = packageData.discountEnd
        let endMs = 0
        if (rawEnd) {
          if (rawEnd instanceof Date) endMs = rawEnd.getTime()
          else if (typeof rawEnd === 'number') endMs = rawEnd
          else if (typeof rawEnd === 'string') endMs = new Date(rawEnd).getTime()
          else if (rawEnd.iso) endMs = new Date(rawEnd.iso).getTime()
        }
        const hasActiveDiscount =
          packageData.discountPrice != null &&
          packageData.discountPrice > 0 &&
          endMs > Date.now()

        this.packageData = hasActiveDiscount
          ? {
              ...packageData,
              originalPrice: packageData.price,
              effectivePrice: packageData.discountPrice,
              discounted: true,
              price: packageData.discountPrice
            }
          : {
              ...packageData,
              originalPrice: packageData.price,
              effectivePrice: packageData.price,
              discounted: false
            }
        this.paramPriceId = priceId
        this.paramType = type
        // Don't skip steps - let the user go through zipcode first, then skip package selection
        // The step will be set to 3 in handleContinue method
      }
    } else if (type) {
      // Only type parameter exists, proceed normally
      // this.paramType = type
    }

    document.addEventListener(
      typeof cordova !== 'undefined' ? 'deviceready' : 'DOMContentLoaded',
      async () => {
        this.isWeb = typeof window.cordova === 'undefined'
      }
    )
  }
}
</script>
<style lang="scss">
.option-card {
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid rgba(11, 51, 106, 0.06);
  padding: 32px 32px;
  background-color: #fff;
  box-shadow: 0px 8px 8px rgba(1, 27, 96, 0.04);
  border-radius: 22px;

  .option-title {
    color: #475f83;
    font-weight: 900 !important;
  }

  .option-icon {
    filter: drop-shadow(0px 1px 8px rgba(151, 192, 255, 0.31));
  }
}

.text-green {
  color: green;
}
</style>
<style scoped>
.summary-list {
  margin: 0;
  padding: 0 !important;
  list-style: none;
}

.summary-list li {
  position: relative;
  padding-left: 18px;
  margin-bottom: 8px;
}

.summary-list li::after {
  position: absolute;
  content: "";
  left: 0;
  top: 7px;
  width: 8px;
  height: 8px;
  background: rgba(45, 154, 71, 1);
  border-radius: 50%;
}

h3 .muted {
  color: #cacaca;
  font-weight: normal;
}

/* Coupon Section Styles */
.coupon-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 20px 0;
  border: 2px solid #e9ecef;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.coupon-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.coupon-icon {
  color: #2D9A47;
  font-size: 24px;
  margin-right: 12px;
}

.coupon-title {
  color: #2D9A47;
  font-weight: 600;
  margin: 0;
  font-size: 18px;
}

.coupon-form {
  width: 100%;
}

.coupon-input-group {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.coupon-input {
  flex: 1;
}

.coupon-btn {
  min-width: 100px;
  height: 40px;
  border-radius: 8px;
  font-weight: 600;
  text-transform: none;
}

.coupon-message {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.coupon-message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.coupon-message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.coupon-message.info {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.applied-coupon {
  background: linear-gradient(135deg, #2D9A47 0%, #1e7a34 100%);
  color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 16px rgba(45, 154, 71, 0.3);
}

.coupon-details {
  flex: 1;
}

.coupon-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.coupon-code {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
}

.coupon-discount {
  background: #FFD700;
  color: #333;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 12px;
}

.coupon-description {
  font-size: 14px;
  margin-bottom: 4px;
  opacity: 0.9;
}

.coupon-expiry {
  font-size: 12px;
  opacity: 0.8;
}

.remove-coupon-btn {
  color: white !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  margin-left: 16px;
}

.remove-coupon-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.coupon-applied-text {
  color: #2D9A47;
  font-weight: 500;
}

.coupon-discount-display {
  margin: 16px 0;
  padding: 12px 16px;
  background: linear-gradient(135deg, #e8f5e8 0%, #d4edda 100%);
  border-radius: 8px;
  border-left: 4px solid #2D9A47;
}

.coupon-discount-text {
  color: #155724;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

/* Student signup steps — same flat centered style as the zip-code screen */
.studentStepForm {
  max-width: 680px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.studentStepForm .form-group .v-btn {
  border-radius: 30px;
  min-width: 200px;
}

.studentStepTrust {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 6px;
  color: #6c757d;
  font-size: 13px;
}

.studentStepTrust .v-icon {
  color: #2d9a47 !important;
}

/* OTP dialog: subtext, countdown, inline error */
.otp-subtext {
  color: #6c757d;
  font-size: 14px;
  line-height: 1.6;
  margin: 6px 0 14px;
}

.otp-timer {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  background: #eaf7ee;
  color: #1e7a34;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 14px;
}

.otp-timer .mdi {
  font-size: 15px;
}

.otp-timer-expired {
  background: #fdecea;
  color: #c0392b;
}

.otp-error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #fdecea;
  border: 1px solid #f2b3ac;
  color: #c0392b;
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;
}

/* Where did you hear about us? — own step before checkout */
.hear-about-step {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 20px;
  padding: 36px 32px;
  border: 2px solid #e9ecef;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  max-width: -webkit-fill-available;
}

.hear-about-step-head {
  text-align: center;
  margin-bottom: 26px;
}

.hear-about-badge {
  width: 52px;
  height: 52px;
  margin: 0 auto 14px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2D9A47 0%, #1e7a34 100%);
  box-shadow: 0 6px 18px rgba(45, 154, 71, 0.35);
}

.hear-about-step-title {
  color: #212529;
  font-weight: 700;
  font-size: 24px;
  margin: 0 0 6px;
}

.hear-about-subtitle {
  color: #6c757d;
  font-size: 14px;
  margin: 0;
}

.hear-about-continue {
  margin-top: 24px;
  height: 48px !important;
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.3px;
}

.hear-about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.hear-about-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #ffffff;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  cursor: pointer;
  transition: all 0.25s ease;
  text-align: left;
  outline: none;
}

.hear-about-chip:hover {
  border-color: #2D9A47;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(45, 154, 71, 0.15);
}

.hear-about-chip.selected {
  background: linear-gradient(135deg, #2D9A47 0%, #1e7a34 100%);
  border-color: #1e7a34;
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(45, 154, 71, 0.3);
}

.hear-about-chip-icon {
  font-size: 20px;
  color: inherit !important;
}

.hear-about-chip.selected .hear-about-chip-icon,
.hear-about-chip.selected .hear-about-check {
  color: #ffffff !important;
}

.hear-about-check {
  margin-left: auto;
  font-size: 18px;
}

.hear-about-other {
  margin-top: 14px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .coupon-section {
    padding: 16px;
    margin: 16px 0;
  }

  .hear-about-step {
    padding: 24px 16px;
  }

  .hear-about-step-title {
    font-size: 20px;
  }

  .hear-about-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .hear-about-chip {
    padding: 10px 12px;
    font-size: 13px;
  }

  .coupon-input-group {
    flex-direction: column;
    gap: 8px;
  }

  .coupon-btn {
    width: 100%;
  }

  .applied-coupon {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .remove-coupon-btn {
    margin-left: 0;
    width: 100%;
  }
}

/* Order Summary — discount banner */
.os-original-price {
  font-size: 16px;
  text-decoration: line-through;
  color: #9ca3af;
  margin-right: 8px;
  font-weight: 500;
}

.discount-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #fdf2f8;
  border: 1px dashed #f9a8d4;
  border-radius: 12px;
  padding: 12px 14px;
  margin: 0 0 16px;
  flex-wrap: wrap;
}

.discount-banner-left {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1 1 260px;
  min-width: 0;
}

.discount-banner-bolt {
  background: #a855f7;
  color: #fff;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.discount-banner-title {
  color: #be185d;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
}

.discount-banner-sub {
  color: #6b7280;
  font-size: 12px;
  margin-top: 2px;
}

.discount-banner-timer {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.discount-banner-timer .dc-chip {
  background: #0b1220;
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.discount-banner-timer .dc-chip sub {
  font-size: 9px;
  opacity: 0.7;
  margin-left: 2px;
  bottom: 0;
}

.discount-banner-timer .dc-sep {
  color: #6b7280;
  font-weight: 700;
}

@media (max-width: 600px) {
  .discount-banner {
    padding: 10px 12px;
  }
  .discount-banner-title {
    font-size: 13px;
  }
  .discount-banner-sub {
    font-size: 11px;
  }
  .discount-banner-timer .dc-chip {
    font-size: 11px;
    padding: 3px 6px;
  }
}

/* Discount-expired dialog */
.discount-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  padding: 0 !important;
}

.discount-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px 12px;
  background: linear-gradient(135deg, #fdf2f8 0%, #faf5ff 100%);
  border-bottom: 1px dashed #f9a8d4;
}

.discount-dialog-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #a855f7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.discount-dialog-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #be185d;
  line-height: 1.3;
}

.discount-dialog-body {
  padding: 18px 24px 6px;
}

.discount-dialog-text {
  margin: 0 0 14px;
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
}

.discount-dialog-prices {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 14px;
}

.dd-price-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 90px;
}

.dd-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
  font-weight: 600;
}

.dd-value {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  margin-top: 2px;
}

.dd-old .dd-value {
  color: #9ca3af;
}

.dd-new .dd-value {
  color: #059669;
}

.dd-arrow {
  color: #9ca3af;
}

.discount-dialog-sub {
  margin: 0 0 6px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
}

.discount-dialog-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 12px 18px 18px;
}

.discount-dialog-cancel {
  color: #6b7280 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

.discount-dialog-proceed {
  background: #009966 !important;
  color: #fff !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  padding: 0 18px !important;
}

@media (max-width: 480px) {
  .discount-dialog-header {
    padding: 16px 18px 10px;
  }
  .discount-dialog-body {
    padding: 14px 18px 4px;
  }
  .discount-dialog-actions {
    padding: 10px 14px 14px;
    flex-wrap: wrap;
  }
  .discount-dialog-proceed {
    flex: 1;
  }
  .dd-price-block {
    min-width: 0;
  }
  .dd-value {
    font-size: 19px;
  }
}

.social-signup-wrapper {
  max-width: 420px;
  margin: 0 auto 8px;
}
.social-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
}
.social-btn .social-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.google-btn {
  background-color: #ffffff !important;
  color: rgba(0, 0, 0, 0.75) !important;
  border-color: rgba(0, 0, 0, 0.2) !important;
}
.apple-btn {
  color: #ffffff !important;
}
.social-signup-divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 18px 0 6px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 13px;
}
.social-signup-divider::before,
.social-signup-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.social-signup-divider span {
  padding: 0 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
</style>
